export default __webpack_public_path__ + "static/media/sf3.7b4e4e82.jpeg";